import { Colors } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

const styles = {
	link: css({
		color: Colors.LIGHT_GRAY5,
		textDecoration: "underline",
		":hover": { color: Colors.LIGHT_GRAY4 },
	}),
};
interface Props {
	dark: boolean;
}

const CookieBanner: React.FC<Props> = ({ dark }) => {
	return (
		<CookieConsent
			location="bottom"
			buttonText="OK"
			cookieName="sypt-banner-cookie"
			style={{
				background: dark ? Colors.LIGHT_GRAY5 : Colors.DARK_GRAY5,
				color: dark ? Colors.DARK_GRAY5 : Colors.LIGHT_GRAY5,
			}}
			buttonStyle={{ backgroundColor: Colors.GREEN3, color: Colors.LIGHT_GRAY5, fontSize: "13px" }}
			expires={150}
		>
			We use Cookies and Google Analytics to improve your user experience. By continuing to use this
			site, you consent to our{" "}
			<Link to="/privacy/" {...styles.link}>
				Privacy Policy
			</Link>
		</CookieConsent>
	);
};

export default CookieBanner;



// WEBPACK FOOTER //
// ./src/Public/CookieBanner.tsx